/*
 * @Author: your name
 * @Date: 2021-06-04 23:00:08
 * @LastEditTime: 2021-07-12 09:40:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\main.js
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import './assets/fonts/iconfont.css'
import './global.less'
import VueClipboard from 'vue-clipboard2' //实现复制内容到剪贴板功能
import moment from "moment";
import 'moment/locale/zh-cn'
import plugins from '../utils/plugins'// 引入
import vcolorpicker from 'vcolorpicker'
import VueQriously from 'vue-qriously'
import Print from 'vue-print-nb' //打印 使用方法 v-print="'#容器ID'"
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn');

import TIM from 'tim-js-sdk-ws';
import TIMUploadPlugin from 'tim-upload-plugin';
let options = {
  SDKAppID: 1400494746 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
 };
//  创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
 let tim = TIM.create(options); // SDK 实例通常用 tim 表示
//  设置 SDK 日志输出级别，详细分级请参见 <a href="https://web.sdk.qcloud.com/im/doc/zh-cn//SDK.html#setLogLevel">setLogLevel 接口的说明</a>
//  tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
 tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
//  注册腾讯云即时通信 IM 上传插件
 tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin}); 
Vue.prototype.$tim = tim
Vue.prototype.$TIMS = TIM

Vue.prototype.$moment = moment;//挂载到当前vue实例对象
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueClipboard)
Vue.use(vcolorpicker)
Vue.use(Print)
Vue.use(VueQriously)
Vue.use(plugins) //通过全局方法 Vue.use() 使用插件
/* eslint-disable no-new */

Vue.prototype.$onCopy = function(certB64,that){ 
  let oInput = document.createElement('input')
  oInput.value = certB64;
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand("Copy") // 执行浏览器复制命令
  that.$message.success("复制成功");
  oInput.remove()
}
//重写js 属性
Number.prototype.toFixed = function (s) {
 
  var type = 1
  if(this < 0){
    type = -1
  }
  var num = Math.abs(this)
  var changenum = (parseInt(num * Math.pow( 10, s ) + 0.5) / Math.pow( 10, s )).toString()
  var index = changenum.indexOf(".")
  if(index < 0 && s > 0){
      changenum = changenum+"."
      for(let i = 0; i < s; i++){
          changenum = changenum + "0"
      }
  } else {
      index = changenum.length - index;
      for(let i = 0; i < (s - index) + 1; i++){
          changenum = changenum + "0"
      }
  }
  return changenum*type + '';
}

Vue.prototype.$isJsonStr= function(str) {
  if (typeof str == 'string') {
      try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
              return true;
          } else {
              return false;
          }

      } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
      }
  }
  console.log('It is not a string!')
}

// import compressImg from '../utils/compressImg'
// Vue.prototype.$compressImg = compressImg;//挂载到当前vue实例对象  cpu过高 

import lrz from 'lrz' //压缩方法
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/SRM/main.js